import React from 'react'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { DefaultButton } from '../Buttons'

const OkButton = withStyles({
  root: {
    color: 'white',
    backgroundColor: '#009688',
    borderColor: '#009688',
    "&:hover": {
      backgroundColor: "#009688"
    }
  },
})(DefaultButton);


const DefaultDialog = (props) => {
  return (
    <Dialog
        open={props.openDialog}
        onClose={props.handleOpen}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth={'md'}
        fullWidth
        scroll="paper"
      >
        <DialogTitle id="alert-dialog-title">{props.dialogTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {props.dialogMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <OkButton onClick={props.handleOpen} color="primary">
            {props.okButtonLabel}
          </OkButton>
        </DialogActions>
      </Dialog>
  )
}

DefaultDialog.propTypes = {
  openDialog: PropTypes.bool.isRequired,
  dialogMessage: PropTypes.string.isRequired,
  dialogTitle: PropTypes.string.isRequired,
  handleOpen: PropTypes.func,
};

DefaultDialog.defaultProps = {
  openDialog: false,
  dialogMessage: '',
  dialogTitle: '!',
  okButtonLabel: 'Ok',
  handleOpen: () => { }
};

export default DefaultDialog